"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceDrugAliasesSchema = exports.drugAliasSchema = exports.drugAliasShape = void 0;
const zod_1 = require("zod");
exports.drugAliasShape = {
    alias: zod_1.z.string().min(1).max(255),
    languageCode: zod_1.z.string().max(10).optional(),
    sortOrder: zod_1.z.number().int().nonnegative(),
};
exports.drugAliasSchema = zod_1.z.object(exports.drugAliasShape);
exports.replaceDrugAliasesSchema = zod_1.z.object({ aliases: zod_1.z.array(exports.drugAliasSchema) });
//# sourceMappingURL=drug-alias.schema.js.map